import {
  Flex,
  Form,
  FormControl,
  FormLabel,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { CurrentlySelectedZipCityState } from '../ForYouContent'
import { GeoArea } from '../../../api/gqlaxy/gql/generated/graphql'

const MSG = defineMessages({
  switchToAnotherMarket: {
    id: 'MarketSwitchDropdown',
    defaultMessage: 'Switch to another market'
  },
  addNewMarket: {
    id: 'MarketSwitchDropdown.addNewMarket',
    defaultMessage: 'Add new'
  }
})

interface MarketSwitchDropdownProps {
  onLocationChange: (zipCityState: CurrentlySelectedZipCityState) => void
  setShowGooglePlaceSelector: (shouldShow: boolean) => void
  favoriteMarkets: Record<string, GeoArea>
  selectedZip?: string
}

export const MarketSwitchDropdown = ({
  selectedZip,
  onLocationChange,
  setShowGooglePlaceSelector,
  favoriteMarkets
}: MarketSwitchDropdownProps) => {
  const intl = useIntl()

  return (
    <Form onSubmit={data => alert(data)}>
      <FormControl>
        <FormLabel srOnly>{intl.formatMessage(MSG.switchToAnotherMarket)}</FormLabel>
        <Menu
          tracking={{
            ui_context: 'For you page',
            descriptor: 'Market select menu',
            guid: 'fpu69wAc4aURzoDjLdTPtd'
          }}
        >
          <MenuButton width='100%'>{intl.formatMessage(MSG.switchToAnotherMarket)}</MenuButton>
          <MenuList>
            {Object.values(favoriteMarkets).map((market: GeoArea, i) => (
              <MenuItem
                key={i}
                onClick={() =>
                  onLocationChange({
                    zipcode: market.zipCode,
                    city: market.city,
                    stateAbbreviation: market.stateAbbreviation
                  })
                }
                as={Flex}
                alignItems='center'
                gap={2}
                value={market.zipCode}
              >
                <Flex width='10%'>{market.zipCode === selectedZip && <Icon name='check' fontSize='xs' />}</Flex>
                <Flex width='90%' textAlign='left'>
                  {market.name}
                </Flex>
              </MenuItem>
            ))}
            <MenuItem paddingLeft={10} onClick={() => setShowGooglePlaceSelector(true)}>
              {intl.formatMessage(MSG.addNewMarket)}
            </MenuItem>
          </MenuList>
        </Menu>
      </FormControl>
    </Form>
  )
}
